<template>
  <div class="Personal flex font">
    <!-- <AsideVue></AsideVue> -->
    <div class="box font">
        <!-- 左边 -->
        <leftList1
          :data="LeftTable"
          :inquiry_id="inquiry_id"
          :rfq="rfq"
          icon="icon-a-RFQ_huaban1"
          :gesUserSalesList="gesUserSalesList"
          :accountList="accountList"
          :countryList="countryList"
          :show="store.contactsRfqShow"
          :type="type"
          :loading="loading"
          :total="total"
          :current-page="currentPage"
          :page-size="pageSize"
          :newModel="newModel"
          :brandList="brandList"
          :sourceList="sourceList"
          :row-class-name="rfqList"
          :supplierList="supplierList"
          :staOptions="staOptions"
          :companyUserList="companyUserList"
          :fuzzySearch="fuzzySearch"
          @cell-click="table"
          @scrollLoad="load"
          @size-change="handleSizeChange"
          @getUserVendors="getSupplier"
          @current-change="handleCurrentChange"
          @close="close"
          @flush="save"
          @typeChange="geTtype"
          @blearSearch="searchs"
          @search="search"
          @new="newVisible"
          @getPersonnel="getGesUserSales"
          @scroll="getScrollUserSales"
          @getCompanyUser="getCompanyUser"
          @getUserGetRfqContactsList="getUserGetRfqContactsList"
          @getUserGetCountry="getUserGetCountry"
          @getModel="getModel"
        ></leftList1>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeMount, nextTick, computed } from "vue";
import leftList1 from "./outsidePage/LeftList-1.vue";
import { ElMessageBox } from "element-plus";
import i18n from "@/assets/lang";
import * as $axios from "@/api/apiRfq/index";
import { Kernaldec } from "@/hooks/useDecrypt";
import { useRouter } from "vue-router";
import { useDemoStore } from "@/pinia/index";
const store = useDemoStore();
const router = useRouter();

// 按钮权限
const rfq = {};

// 加载
const loading = ref(true);

// 接收子组件暴露的方法
const strike = ref();
const newRfqVue = ref(); //新建弹窗
const left2 = ref();

// 顶部搜索方法
const searchRfqList = val => {
  fuzzySearch.value = val;
  save();
};

// 查看的类型
const type = ref({ name: "My", type: "my" });
const geTtype = (e, i) => {
  type.value = e;
  currentPage.value = 1;
  if (i) return;
  save();
};

// 模糊搜索
const fuzzySearch = ref("");
const searchs = e => {
  fuzzySearch.value = e;
  currentPage.value = 1;
  save();
};

// 精确搜索
const searchBox = ref(false);
const searchBoxShow = () => {
  searchBox.value = true;
  getUserGetCountry();
  getUserGetContactsList();
  getUserGetRfqContactsList();
  getModel();
};
// 搜索
const accurateSearch = () => {
  searchBox.value = false;
  save();
};

// 重置搜索
const resetSearch = e => {
  model.value.inquiry = ""; //询盘id
  model.value.client = ""; //客户
  model.value.account = ""; //账号
  model.value.searchCnty = ""; // 国家
  model.value.searchSupplier = ""; //供应商
  model.value.searchSta = ""; //状态
  model.value.inputDate = []; //时间
  model.value.model = ""; //产品
  date.value = [];
  searchBox.value = false;
  if (e) return;
  save();
};

// 供应商
const supplierList = ref([]);
const getSupplier = (e = "") => {
  e = e.trim();
  $axios
    .$quotationGetSupplierList({ token: store.token, keywords: e })
    .then(res => {
      if (res.Status === 0) {
        supplierList.value = res.data.map(item => {
          return {
            label: Kernaldec(item.name),
            id: item.customer_info_id
          };
        });
        // console.log(res.data)
      }
    });
};

// 状态搜索
const staOptions = computed(() => {
  return [
    {
      label: i18n.global.t("rfq.all"),
      value: ""
    },
    {
      label: i18n.global.t("rfq.draft"),
      value: 0
    },
    {
      label: i18n.global.t("rfq.quoting"),
      value: 1
    },
    {
      label: i18n.global.t("rfq.completed"),
      value: 2
    }
  ];
});

//获取联系人
const contactsList = ref([]);
const getUserGetContactsList = (e = "") => {
  e = e.trim();
  $axios.$userGetContactsList({ token: store.token, keyword: e }).then(res => {
    if (res.Status != 0) return;
    contactsList.value = res.data.map(item => {
      return {
        label: Kernaldec(item.firstname) + Kernaldec(item.lastname),
        value: item.customer_info_id
      };
    });
  });
};

// 获取客户
const accountList = ref([]);
const getUserGetRfqContactsList = (e = "") => {
  e = e.trim();
  const data = {
    token: store.token,
    keyword: e,
    isPublic: store.rfqPage,
    isQTN: 0
  };
  $axios.$userGetRfqContactsList(data).then(res => {
    if (res.Status != 0) return;
    accountList.value = res.data.map(item => {
      return {
        label:
          store.type == 4
            ? item.firstname + item.lastname
            : `${item.firstname + item.lastname} [${item.customer_info_id}]`,
        value: item.customer_info_id
      };
    });
  });
};

//获取国家
const countryList = ref([]);
const getUserGetCountry = (e = "") => {
  e = e.trim();
  const data = {
    token: store.token,
    keyword: e
  };
  $axios.$userGetCountry(data).then(res => {
    if (res.Status != 0) return;
    countryList.value = res.data.map(item => {
      return {
        label: item.name,
        value: item.country_id
      };
    });
  });
};

// 获取公司下的所有人员
const companyUserList = ref([]);
const getCompanyUser = (e = "") => {
  e = e.trim();
  $axios
    .$userGetAllCompanyUser({ token: store.token, keyword: e })
    .then(res => {
      if (res.Status !== 0) return;
      companyUserList.value = res.data;
    });
};

// model
var newModel = ref([]);
const getModel = (text = "") => {
  text = text.trim();
  $axios.$product_find({ token: store.token, keywords: text }).then(res => {
    newModel.value = res.data.map(item => {
      return {
        label: item.model,
        id: item.product_id
      };
    });
  });
};
// 品牌列表
const brandList = ref([]);
const brandLoading = ref(false);
const getBrand = (text = "") => {
  text = text.trim();
  brandLoading.value = true;
  $axios.$product_brand({ token: store.token, keywords: text }).then(res => {
    brandLoading.value = false;
    brandList.value = res.data.map(item => {
      return {
        label: item.brand_name,
        id: item.brand_id
      };
    });
  });
};

// 获取来源列表
const sourceList = ref([]);
const getFromList = e => {
  $axios.$getFromList({ token: store.token, keywords: e }).then(res => {
    if (res.Status != 0) return;
    sourceList.value = res.data;
  });
};

// 日期改变时触发
const date = ref([]);
const changeDate = e => {
  model.value.inputDate = e == null ? [] : e;
};

// 共用搜索方法
const model = ref({
  inquiry: "", //询盘id
  client: "", //客户
  account: "", //账号
  searchCnty: "", // 国家
  searchSupplier: "", //供应商
  searchSta: "", //状态
  inputDate: [], //时间
  companyUser: "", //创建人
  model: "" //model
});
const search = e => {
  model.value = e;
  save();
};

// 获取所有的用户及下级信息
const gesUserSalesList = ref([]);
const keywordUser = ref("");
const getGesUserSales = (e = "") => {
  e = e.trim();
  keywordUser.value = e;
  const data = {
    token: store.token,
    keyword: e,
    isPublic: store.rfqPage,
    isQTN: 0
  };
  $axios.$userGesUserSales(data).then(res => {
    if (res.Status === 0) {
      gesUserSalesList.value = [
        { name: i18n.global.t("rfq.all"), type: "all" },
        { name: i18n.global.t("rfq.my"), type: "my" },
        ...res.data
      ];
    }
  });
};
// 下拉加载触发
const userPage = ref(1);
const getScrollUserSales = () => {
  userPage.value++;
  $axios
    .$userGesUserSales({
      token: store.token,
      keyword: keywordUser.value,
      page: userPage.value
    })
    .then(res => {
      if (res.Status === 0) {
        gesUserSalesList.value = [...gesUserSalesList.value, ...res.data];
      }
    });
};

// 左边部分
const LeftTable = ref([]);
const total = ref();
const page = ref();
const dataObj = ref({
  page: 1, //页数
  limit: 25, //显示条数
  keywords: fuzzySearch.value
});
const postLefttable = () => {
  loading.value = true;
  const data = {
    token: store.token,
    purchaser: store.type == 3 ? store.userId : "",
    page: dataObj.value.page, //页数
    limit: dataObj.value.limit, //显示条数
    type: type.value.type,
    keywords: dataObj.value.keywords,
    from: model.value.source,
    brand_id: model.value.brand,
    inquiry_id: model.value.inquiry,
    customerName: model.value.client,
    country_name: model.value.searchCnty,
    account: model.value.account,
    Customer_type: model.value.searchSupplier,
    status: model.value.searchSta,
    create_time: model.value.inputDate,
    product_id: model.value.model,
    createUser: model.value.companyUser,
    isQTN: 0, //区分是询盘还是报价
    isPublic: 0, // 区分是公开询盘还是个人询盘
    isContactRFQ: 0,
    customer_inquiry_type:2
  };
  if (store.type != 4) {
    $axios.$Inside_polling(data).then(res => {
      loading.value = false;
      if (res.Status == 0) {
        page.value = res.data.last_page;
        total.value = res.data.total;
        LeftTable.value = [
          ...LeftTable.value,
          ...res.data.data.map(i => {
            return {
              ...i,
              country: {
                name: i.country.name == undefined ? "-" : i.country.name
              },
              owner: i.owner == "" ? "-" : i.owner,
              vendor: i.vendor == "" ? "-" : i.vendor,
            };
          })
        ];
      } else {
        rfqId.value = "";
      }
    });
  } else {
    $axios.$pollingOutside_polling(data).then(res => {
      loading.value = false;
      if (res.Status == 0) {
        page.value = res.data.last_page;
        total.value = res.data.total;
        LeftTable.value = [
          //这里要做去重
          ...LeftTable.value,
          ...res.data.data.map(i => {
            return {
              ...i,
              country: {
                name: i.country.name == undefined ? "-" : i.country.name
              },
              owner: i.owner == "" ? "-" : i.owner,
              vendor: i.vendor == "" ? "-" : i.vendor,
            };
          })
        ];
      } else {
        rfqId.value = "";
      }
    });
  }
};

// 上拉加载更多
const load = () => {
  if (LeftTable.value.length < 25 || page.value <= dataObj.value.page) return; //避免数据出现重复的
  loading.value = true;
  dataObj.value.page++;
  dataObj.value.keywords = fuzzySearch.value;
  postLefttable();
  currentPage.value = dataObj.value.page;
};

// 分页
const currentPage = ref(1); //当前页数
const pageSize = ref(20); //每页显示条目个数
const handleSizeChange = e => {
  //page-size 改变时触发
  pageSize.value = e;
  dataObj.value.limit = e;
  save(rfqId.value);
};

const handleCurrentChange = e => {
  //current-page 改变时触发
  dataObj.value.page = e;
  currentPage.value = dataObj.value.page;
  save();
};

// 新建弹窗
const newVisible = () => {
  newRfqVue.value.newVisible = true;
  currentPage.value = 1;
};

// 修改状态
const changeStatus = e => {
  const index = LeftTable.value.findIndex(
    item => item.inquiry_id == e.inquiry_id
  );
  LeftTable.value[index].state = e.state;
  LeftTable.value[index].stateCode = e.stateCode;
  LeftTable.value[index].items_count = e.items_count;
  rfqDetails.value.stateCode = e.stateCode;
};

// 子组件保存触发
var timer;
const save = (id, is) => {
  // rfqId.value = id || ''
  clearTimeout(timer);
  timer = setTimeout(() => {
    // dataObj.value.page = 1
    loading.value = true;
    if (is == 1) {
      //新建清空搜索条件
      fuzzySearch.value = "";
      resetSearch(true);
    }
    const data1 = {
      token: store.token,
      purchaser: store.type == 3 ? store.userId : "",
      page: currentPage.value, //页数
      limit: pageSize.value, //显示条数
      type: type.value.type,
      keywords: fuzzySearch.value,
      from: model.value.source,
      brand_id: model.value.brand,
      inquiry_id: model.value.inquiry,
      customerName: model.value.client,
      country_name: model.value.searchCnty,
      account: model.value.account,
      Customer_type: model.value.searchSupplier,
      status: model.value.searchSta,
      create_time: model.value.inputDate,
      product_id: model.value.model,
      createUser: model.value.companyUser,
      isQTN: 0, //区分是询盘还是报价
      isPublic: 0, // 区分是公开询盘还是个人询盘
      isContactRFQ: 0,
      Inside_polling:2
    };
    if (store.type != 4) {
      $axios.$Inside_polling(data1).then(res => {
        loading.value = false;
        page.value = res.data.last_page;
        total.value = res.data.total;
        let i = res.data.data.findIndex(i => i.inquiry_id == id);
        i === -1 || table(res.data.data[i], "no");
        LeftTable.value = res.data.data.map(i => {
          return {
            ...i,
            country: {
              name: i.country.name == undefined ? "-" : i.country.name
            },
            owner: i.owner == "" ? "-" : i.owner,
            vendor: i.vendor == "" ? "-" : i.vendor,
          };
        });
      });
    } else {
      $axios.$pollingOutside_polling(data1).then(res => {
        loading.value = false;
        page.value = res.data.last_page;
        total.value = res.data.total;
        let i = res.data.data.findIndex(i => i.inquiry_id == id);
        i === -1 || table(res.data.data[i], "no");
        LeftTable.value = res.data.data.map(i => {
          return {
            ...i,
            country: {
              name: i.country.name == undefined ? "-" : i.country.name
            },
            owner: i.owner == "" ? "-" : i.owner,
            vendor: i.vendor == "" ? "-" : i.vendor,
          };
        });
      });
    }

    if (is === 1) {
      nextTick(() => {
        left2.value.leftBox.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      });
      strike.value.personalMainRef.mainBoxRef.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    } else if (is === 2) {
      left2.value.anchor.forEach(item => {
        nextTick(() => {
          if (item.className == "flex aic list success-row") {
            left2.value.leftBox.scrollTo({
              top: item.offsetTop - 138,
              behavior: "smooth"
            });
          }
        });
      });
    } else if (is === 3) {
      //删除询盘
      rfqId.value = "";
    }
  }, 400);
};

const close = () => {
  //点击右边三角形触发
  store.changeContactsRfq(true);
};
const open = () => {
  //点击右边三角形触发 打开
  store.changeContactsRfq(false);
};

let inquiry_id = ref(0);
onMounted(() => {
  type.value = { name: i18n.global.t("rfq.my"), type: "my" };
  let queryList = router.currentRoute.value.query;
  if (queryList.inquiry_id) {
    type.value = {
      name: "All",
      type: "all"
    };
    searchs(queryList.inquiry_id, true);
    save(queryList.inquiry_id);
    inquiry_id.value = queryList.inquiry_id;
    // rfqId.value = queryList.inquiry_id
    store.changePersonal(true);
    // strike.value.personalMainRef.handleRfqList()
  } else {
    if (LeftTable.value.length > 25) return; //避免数据出现重复的
    postLefttable();
  }
  getGesUserSales();
  getModel();
  getBrand();
  getFromList();
  getCompanyUser();
  getUserGetRfqContactsList();
  getUserGetCountry();
  getSupplier();
});

onBeforeMount(() => {
  store.changeRfqPage(4);
  store.changeRfqPurview(true);
});

const rfqId = ref(); // 左边表格的id
const rfqDetails = ref({});
const firstname = ref("");
// 点击表格高亮
const table = (row, is) => {};

const rfqList = ({ row, rowIndex }) => {
  if (row.inquiry_id === rfqId.value) {
    return "success-row";
  }
  return "";
};

// 相关采购报价离开效验
const relatedPurchase = () => {
  let tableData = strike.value.personalMainRef.purchaseQtnRef.tableData;
  let data = tableData.map(item => {
    return {
      product_id: item.product_id,
      brand_id: item.brand_id,
      Qty: item.Qty,
      purchaser_id: item.purchaser_id,
      supplier_id: item.supplier_id,
      leadingtime: item.leadingtime,
      product_condition: item.product_condition,
      quotation_price: item.quotation_price * 1,
      profit_rate: item.profit_rate
    };
  });
  return data;
};

const isObjectValueEqual = (a, b) => {
  // 判断两个对象是否指向同一内存，指向同一内存返回 true
  if (a === b) return true;
  // 获取两个对象键值数组
  let aProps = Object.getOwnPropertyNames(a);
  let bProps = Object.getOwnPropertyNames(b);
  if (aProps.length !== bProps.length) return false;
  for (let prop in a) {
    // 判断 a 的键值，在 b 中是否存在，不存在，返回 false
    if (b.hasOwnProperty(prop)) {
      if (typeof a[prop] === "object") {
        if (!isObjectValueEqual(a[prop], b[prop])) return false;
      } else if (a[prop] !== b[prop]) {
        return false;
      }
    } else {
      return false;
    }
  }
  return true;
};
</script>

<style>
.success-row {
  --el-table-tr-bg-color: #e6f0ff;
  background-color: #e6f0ff;
}
</style>

<style lang="less" scoped>
@import "./Personal.less";
</style>